import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-auction-winner-pop-up',
  templateUrl: './auction-winner-pop-up.component.html',
  styles: [
  ]
})
export class AuctionWinnerPopUpComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AuctionWinnerPopUpComponent>) { }

  ngOnInit(): void {

  }
}
